import { render, staticRenderFns } from "./comAdd.vue?vue&type=template&id=c43ff5d6&scoped=true&"
import script from "./comAdd.vue?vue&type=script&lang=js&"
export * from "./comAdd.vue?vue&type=script&lang=js&"
import style0 from "./comAdd.vue?vue&type=style&index=0&id=c43ff5d6&lang=scss&scoped=true&"
import style1 from "./comAdd.vue?vue&type=style&index=1&id=c43ff5d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43ff5d6",
  null
  
)

export default component.exports